<style lang="scss" scoped>
@import "core";

.my-lead {
  margin-bottom: 15px;
  color: $color-strong;
}

.my-ie-message {
  margin-top: 10px;

  &__guide {
    font-size: 90%;
  }
}

.my-step-list {
  & > li {
    margin-top: .5em;
  }
}
</style>



<template>
  <error-dialog-base ref="base">
    <div slot="header">お使いの端末の<wbr>ストレージの空き容量が<wbr>不足しています</div>
    <div slot="message" is="template">不要なデータを削除頂く、もしくは他の端末で再度お試しください。</div>

    <div class="my-ie-message">
      <p class="my-ie-message__guide">※Internet Explorerをお使いの場合、このエラーはブラウザの設定によって表示されている可能性があります。<br>以下の手順をお試しください。</p>
      <ol class="my-step-list">
        <li>[インターネットオプション]を開く</li>
        <li>[全般]タブを開く</li>
        <li>[閲覧の履歴]の[設定]をクリックする</li>
        <li>[キャッシュおよびデータベース]タブを開く</li>
        <li>[Web サイトのキャッシュおよびデータベースを許可する]にチェックを入れる</li>
        <li>一覧表示の中からWEBサイト「dn-sundai.benesse.ne.jp」をクリックする</li>
        <li>[制限の拡張]をクリックする</li>
        <li>[OK]をクリックする</li>
        <li>ブラウザを再起動する</li>
      </ol>
    </div>
  </error-dialog-base>
</template>



<script>
import DialogMixin from './dialogMixin';



export default {
  mixins: [DialogMixin],
}
</script>



// WEBPACK FOOTER //
// DialogQuotaExceededError.vue?5c1534f5